module.exports = __webpack_public_path__ + "media/images/icons/icon-quote-8dd0e5eba0c2628ae4ff1263ee529bbf.svg";